let currentIndexHome = 0;

function moveSlide(direction) {
  const slides = document.querySelector(".slides");
  const slideElements = document.querySelectorAll(".slide");
  const totalSlides = slideElements.length;

  // Recalcula a largura do slide dinamicamente
  const slideWidth = slideElements[0].clientWidth;

  // Atualiza o índice
  currentIndexHome += direction;

  if (window.innerWidth <= 768) {
    if (currentIndexHome < 0) {
      currentIndexHome = totalSlides - 1; // Vai para o último slide
    } else if (currentIndexHome >= totalSlides) {
      currentIndexHome = 0; // Volta para o primeiro slide
    }
  } else {
    if (currentIndexHome < 0) {
      currentIndexHome = totalSlides - 1; // Vai para o último slide
    } else if (currentIndexHome >= totalSlides - 1) {
      currentIndexHome = 0; // Volta para o primeiro slide
    }
  }

  // Move os slides
  const offset = currentIndexHome * slideWidth;
  slides.style.transform = `translateX(-${offset}px)`;
  slides.style.transition = "transform 0.3s ease";
}
